import React, { useState } from "react";
import "./ProfileTap.css";
// import { Report } from "../../index";
// import Chevron from "../../../../assets/images/svg/Month Chevron.svg";
// import TabIcon from "../../../../assets/images/svg/subscribe-icon.svg";

const ProfileTap = ({ svg, title, text, isActive, onClick }) => {
  return (
    <div
      className={`profile-tab profile-tab-flex my-account ${
        isActive ? "active" : ""
      }`}
      style={{ position: "relative" }}
      data-tab="profile"
      onClick={onClick}
    >
      <div className="profile-tab-icon">{svg}</div>

      <div className="tab-flex">
        <div className="tab-title">{title}</div>
        <div className="tab-text">{text}</div>
      </div>
      <div className="chevron-div">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="14"
          viewBox="0 0 7 14"
          fill="none"
        >
          <path
            d="M1.06641 12.2463C1.3584 12.2463 1.59326 12.1447 1.79639 11.9416L6.57617 7.28239C6.84912 7.00945 6.96973 6.74284 6.97607 6.40642C6.97607 6.07634 6.84912 5.79704 6.57617 5.53044L1.80273 0.864914C1.59326 0.668137 1.35205 0.566574 1.06641 0.566574C0.482422 0.566574 0 1.0363 0 1.62029C0 1.91228 0.126953 2.17888 0.342773 2.40105L4.48779 6.41277L0.342773 10.4118C0.120605 10.634 0 10.9006 0 11.1926C0 11.7702 0.482422 12.2463 1.06641 12.2463Z"
            fill="white"
            className="chevron"
          />
        </svg>
        {/* <img src={Chevron} /> */}
      </div>
    </div>
  );
};

export default ProfileTap;
